{
  "titleText": {
    "title": "<h1>Scopri come rendere redditizio il tuo consumo di GO</h1>",
    "description": "Prenota una consulenza gratuita con i nostri esperti per ricevere un’analisi su misura su quanto puoi risparmiare con DEC (sui tuoi consumi elettrici).",
    "tag": "SCOPRI TUTTI I VANTAGGI"
  },
  "inquiryTypes": {
    "P": "Energy procurement",
    "S": "Sustainability",
    "I": "Produttore indipendente",
    "U": "Utility",
    "O": "Altro"
  },
  "select": "Seleziona",
  "form": {
    "submit": "Invia",
    "success": "Grazie, la tua richiesta è stata inviata. Ti contatteremo a breve.",
    "error": "Qualcosa è andato storto durante l'invio. Riprova.",
    "fields": {
      "name": {
        "label": "Nome e cognome",
        "error": "Il nome e congnome è obbligatorio"
      },
      "company_name": {
        "label": "Azienda",
        "error": "Il nome dell'azienda è obbligatorio"
      },
      "email": {
        "label": "Email di lavoro",
        "error": "Inserisci un'email valida"
      },
      "additional_info": {
        "label": "Note aggiuntive"
      },
      "number": {
        "label": "Telefono",
        "required": "Il numero di telefono è obbligatorio",
        "invalid": "Inserisci un numero di telefono valido"
      },
      "user_type": {
        "label": "Tipo di richiesta",
        "error": "Seleziona un tipo di richiesta"
      }
    }
  }
}
